(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf_collection"] && !Shopify.designMode) return;
  try {
    
  /* Self-contained. Cart adds are delegated to assets/fmr-cart.js via
     data-fmr-atc-src, which reads the variant id from the hidden input. */
  (function () {
    function init(root) {
      // Hide discount tags that rendered empty.
      root.querySelectorAll('.size-product-grid-item_discount-block .product-image--tag')
        .forEach(function (el) {
          if (!el.textContent.trim()) el.style.display = 'none';
        });

      // Size <select> writes the chosen VARIANT id into its hidden input.
      root.querySelectorAll('select.variant-tc[data-bf-target]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var input = document.getElementById(sel.getAttribute('data-bf-target'));
          if (!input) return;
          var v = sel.value;
          input.value = (v && v !== 'null') ? v : '';
        });
      });

      // Block the add and flash the tooltip when no size is chosen yet.
      root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-bf-needs-variant="true"]');
        if (!btn) return;
        var input = document.getElementById(btn.getAttribute('data-fmr-atc-src'));
        if (input && input.value) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var tip = root.querySelector('#tooltip-card-grid-variant-size-' + btn.getAttribute('data-bf-product'));
        if (!tip) return;
        tip.style.visibility = 'visible';
        clearTimeout(tip._bfTimer);
        tip._bfTimer = setTimeout(function () { tip.style.visibility = 'hidden'; }, 2000);
      }, true);
    }

    document.querySelectorAll('.bf_collection_container').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.bf_collection_container').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  class FmrCountdown extends HTMLElement {
    connectedCallback() {
      var raw = this.getAttribute('data-target-date');
      this.target = raw ? new Date(raw) : null;
      this.fields = {};
      var self = this;
      this.querySelectorAll('[data-unit]').forEach(function (el) {
        self.fields[el.getAttribute('data-unit')] = el;
      });
      if (!this.target || isNaN(this.target.getTime())) return;
      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      var ms = this.target.getTime() - Date.now();
      if (ms < 0) ms = 0;
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var v = {
        days: Math.floor(ms / 86400000),
        hours: Math.floor((ms % 86400000) / 3600000),
        minutes: Math.floor((ms % 3600000) / 60000),
        seconds: Math.floor((ms % 60000) / 1000)
      };
      for (var k in v) {
        if (this.fields[k]) this.fields[k].textContent = pad(v[k]);
      }
    }
  }

  if (!customElements.get('fmr-countdown')) {
    customElements.define('fmr-countdown', FmrCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fmr-collection-favorites"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-fmr-scroll]');
    if (!button) return;

    const scroller = button.closest('.fmr-cfavs__viewport')?.querySelector('.fmr-cfavs__list--slider');
    if (!scroller) return;

    const items = Array.from(scroller.querySelectorAll('.fmr-cfavs__item'));
    if (items.length === 0) return;

    // Scroll to exact item offsets (the snap points), otherwise
    // smooth scrolling fights scroll-snap and can settle back where it started.
    const origin = items[0].offsetLeft;
    const positions = items.map((item) => item.offsetLeft - origin);
    const current = scroller.scrollLeft;

    let target;
    if (button.dataset.fmrScroll === 'prev') {
      target = positions.filter((p) => p < current - 4).pop();
      if (target === undefined) target = 0;
    } else {
      target = positions.find((p) => p > current + 4);
      if (target === undefined) target = scroller.scrollWidth - scroller.clientWidth;
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      scroller.scrollTo({ left: target, behavior: 'auto' });
      return;
    }

    // Belt-and-braces for scroll-snap-type: x mandatory, which can cancel a
    // programmatic smooth scroll and snap back to the starting slide.
    // Targeting exact snap points (above) mitigates it but is not a guarantee
    // across engines, so snapping is also suspended for the animation. The
    // target IS a snap point either way, so the resting position is identical
    // whether or not the suspension turns out to be necessary.
    scroller.style.scrollSnapType = 'none';

    let restored = false;
    const restoreSnap = () => {
      if (restored) return;
      restored = true;
      scroller.style.removeProperty('scroll-snap-type');
    };

    scroller.scrollTo({ left: target, behavior: 'smooth' });

    // The timeout is the primary restore; scrollend is only an early-out once
    // the scroll has demonstrably started. Attaching scrollend before the
    // scrollTo above risks catching a stale/immediate event and restoring
    // snapping mid-flight, which cancels the very scroll we just asked for.
    requestAnimationFrame(() => {
      scroller.addEventListener('scrollend', restoreSnap, { once: true });
    });
    setTimeout(restoreSnap, 700);
  });

  // Only offer an arrow in a direction the rail can actually travel: no prev at
  // the start, no next at the end, and neither if the row happens to fit.
  //
  // Uses the `hidden` attribute rather than a CSS class so the button leaves the
  // accessibility tree and tab order too — a focusable control that does nothing
  // is worse than no control.
  (() => {
    // Fractional scrollWidth/clientWidth means the far edge rarely lands on an
    // exact integer, so compare with a small tolerance instead of ===.
    const EDGE_TOLERANCE = 2;

    const syncArrows = (viewport) => {
      const scroller = viewport.querySelector('.fmr-cfavs__list--slider');
      const prev = viewport.querySelector('[data-fmr-scroll="prev"]');
      const next = viewport.querySelector('[data-fmr-scroll="next"]');
      if (!scroller || !prev || !next) return;

      const max = scroller.scrollWidth - scroller.clientWidth;
      const scrollable = max > EDGE_TOLERANCE;

      prev.hidden = !scrollable || scroller.scrollLeft <= EDGE_TOLERANCE;
      next.hidden = !scrollable || scroller.scrollLeft >= max - EDGE_TOLERANCE;
    };

    const observed = new WeakSet();

    const init = (root = document) => {
      for (const viewport of root.querySelectorAll('.fmr-cfavs__viewport')) {
        const scroller = viewport.querySelector('.fmr-cfavs__list--slider');
        if (!scroller || observed.has(scroller)) continue;
        observed.add(scroller);

        scroller.addEventListener('scroll', () => syncArrows(viewport), { passive: true });

        // Card images load lazily, so scrollWidth is not final at first paint —
        // re-check whenever the scroller or its content changes size.
        if ('ResizeObserver' in window) {
          const ro = new ResizeObserver(() => syncArrows(viewport));
          ro.observe(scroller);
          const first = scroller.querySelector('.fmr-cfavs__item');
          if (first) ro.observe(first);
        }

        syncArrows(viewport);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    // Theme editor re-renders a section in place without a page load.
    document.addEventListener('shopify:section:load', (event) => {
      const target = event.target;
      if (target instanceof Element) init(target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fmr-mobile-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFmrMobileNav() {
      var nav = document.getElementById('fmr-mnav');
      if (!nav) return;
      var details = document.getElementById('Details-menu-drawer-container');

      var trigger = details ? details.querySelector('.header__icon--menu') : null;
      var lastFocused = null;

      function resetHeaderDrawer() {
        if (!details) return;
        details.open = false;
        details.classList.remove('menu-open');
        details.removeAttribute('open');
      }

      function getFocusable() {
        return Array.prototype.slice
          .call(
            nav.querySelectorAll(
              'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
            )
          )
          .filter(function (el) {
            return el.offsetParent !== null || el.getClientRects().length > 0;
          });
      }

      function openNav() {
        lastFocused = document.activeElement;
        nav.removeAttribute('inert');
        nav.setAttribute('aria-hidden', 'false');
        document.body.classList.add('fmr-mnav-open');
        resetHeaderDrawer();
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        var closeBtn = nav.querySelector('.fmr-mnav__close');
        if (closeBtn) closeBtn.focus();
      }

      function closeNav() {
        nav.setAttribute('aria-hidden', 'true');
        nav.setAttribute('inert', '');
        document.body.classList.remove('fmr-mnav-open');
        resetHeaderDrawer();
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        var target = lastFocused || trigger;
        if (target && typeof target.focus === 'function') target.focus();
      }

      // Start inert so the off-screen drawer is removed from tab order / a11y tree.
      nav.setAttribute('inert', '');

      // Intercept Horizon's hamburger button (the <summary> inside the mobile drawer)
      if (trigger) {
        trigger.setAttribute('aria-controls', 'fmr-mnav');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', function (e) {
          if (window.innerWidth >= 990) return;
          e.preventDefault();
          openNav();
          requestAnimationFrame(function () {
            resetHeaderDrawer();
            if (trigger) trigger.setAttribute('aria-expanded', 'true');
          });
        });
      }

      // (Search placement is handled natively by Horizon: the mobile search
      // renders at grid-area leftB next to the hamburger — no JS move needed.)

      // Close button
      var closeBtn = nav.querySelector('.fmr-mnav__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', closeNav);
      }

      // Focus trap: keep Tab within the open dialog
      nav.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        if (nav.getAttribute('aria-hidden') !== 'false') return;
        var focusable = getFocusable();
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      // Escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && nav.getAttribute('aria-hidden') === 'false') {
          closeNav();
        }
      });

      // Close on resize to desktop
      window.addEventListener('resize', function () {
        if (window.innerWidth >= 990 && nav.getAttribute('aria-hidden') === 'false') {
          closeNav();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFmrMobileNav);
    } else {
      initFmrMobileNav();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
